import { Platform } from "react-native";

const LAST_RELOAD_KEY = "trovie:stale-chunk-reload";
const RELOAD_GAP_MS = 60_000;

/**
 * Whether the page should reload because a web route chunk failed to load (TRO-1972), and records
 * that it is about to.
 *
 * A deploy replaces every hashed chunk, so a tab opened before it asks for a file that is gone, and
 * a fresh load fetches the current ones. At most once a minute per tab, so a chunk that really is
 * unreachable shows the error screen instead of reloading forever.
 */
export function claimStaleChunkReload(error: Error, now = Date.now()): boolean {
  if (Platform.OS !== "web" || error.name !== "AsyncRequireError") return false;
  try {
    if (now - Number(sessionStorage.getItem(LAST_RELOAD_KEY) ?? 0) < RELOAD_GAP_MS) return false;
    sessionStorage.setItem(LAST_RELOAD_KEY, String(now));
  } catch {
    return false;
  }
  return true;
}
